import { css, html, nothing, type TemplateResult } from 'lit';
import { when } from 'lit-html/directives/when.js';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '../tm-base.component';

export interface SummaryTileVm {
    id: string | number;
    totalAmount: number | string | TemplateResult;
    count: number;
    isSelected: boolean;
    title: string;
}

export const nullTileModel: SummaryTileVm = {
    id: '',
    totalAmount: 0,
    count: 0,
    isSelected: false,
    title: '',
};

export const tagName = 'tm-summary-tile';
@customElement(tagName)
export class TmSummaryTile extends TmBaseComponent {
    @property({
        type: Boolean,
    })
    public isSelected = false;

    @property({
        type: Number,
    })
    public width = 125;

    @property({
        attribute: false,
    })
    public summaryTile?: SummaryTileVm;

    @property({ type: Boolean })
    public showCount = true;

    protected render() {
        const { summaryTile } = this;
        if (!summaryTile) {
            return nothing;
        }

        return html`<div
            class=${classMap({
                'bg-primary rounded-lg shadow overflow-hidden border': true,
                'border-brand': this.isSelected,
            })}
        >
            <button
                class=${classMap({
                    'flex flex-col items-start justify-start w-full py-4 pl-6 pr-4 pointer': true,
                    'bg-brand-15': this.isSelected,
                })}
                id=${this.id}
                @click=${this.handleTileClick}
                @keypress=${this.handleTileClick}
                .disabled=${summaryTile.count === 0}
            >
                <div
                    class=${classMap({
                        'text-sm text-left': true,
                        'font-medium': this.isSelected,
                        'text-brand': this.isSelected,
                    })}
                >
                    ${summaryTile.title}
                </div>
                ${when(
                    this.showCount,
                    () => html`<span class="text-xl">${summaryTile.count}</span>`
                )}
                <span class="text-xs text-left">${summaryTile.totalAmount}</span>
            </button>
        </div>`;
    }

    private handleTileClick() {
        this.dispatchEvent(
            new CustomEvent<SummaryTileVm>('tileClicked', { detail: this.summaryTile })
        );
        this.requestUpdate();
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmSummaryTile;
    }
}
